export const ImportMapProviderSymbol = Symbol('ImportMapProviderSymbol')
